/* import __COLOCATED_TEMPLATE__ from './label.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { restartableTask } from 'ember-concurrency-decorators';
import { captureException } from '@sentry/browser';
import { get } from 'embercom/lib/ajax';
import type { TaskGenerator } from 'ember-concurrency';
import { taskFor } from 'ember-concurrency-ts';

export default class ReferralLabel extends Component {
  @service appService: any;
  @service intercomEventService: any;
  @tracked isOpen = false;
  @tracked showLabel = false;
  @tracked referredBy = '';

  constructor(owner: unknown, args: any) {
    super(owner, args);
    taskFor(this.checkReferral).perform();
  }

  get appId() {
    return this.appService.app.id;
  }

  get canSeeFinCostUnderstanding() {
    return this.appService.app.canSeeFinCostUnderstanding;
  }

  @restartableTask
  *checkReferral(): TaskGenerator<any> {
    try {
      let isReferred = yield get(`/ember/referrals/is_referred?app_id=${this.appId}`);
      this.showLabel = isReferred.is_referred;
      this.referredBy = isReferred.referred_by;
    } catch (error) {
      captureException(new Error('is_referred get failed'), {
        fingerprint: ['is_referred'],
        tags: {
          responsibleTeam: 'team-self-serve',
          responsible_team: 'team-self-serve',
        },
      });
    }
  }

  @action
  onModalOpen(object: string) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object,
      context: 'show_referral_modal',
    });
    this.isOpen = true;
  }

  @action
  onModalClose(object: string) {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object,
      context: 'close_referral_modal',
    });
    this.isOpen = false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Referral::Label': typeof ReferralLabel;
    'referral/label': typeof ReferralLabel;
  }
}
